import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent {

  branchofficeSlug = '';
  constructor(
    private routeActivated: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }
}
